import { useState } from 'react';
import { Box } from '@osmosis/tailwind-ui/components/Box';
import { H2 } from '@osmosis/tailwind-ui/components/Text';
import { BannerAccordionButton } from './BannerAccordionButton';
import { BannerAccordionPanel } from './BannerAccordionPanel';

/**
 * BannerAccordion.
 */
export const BannerAccordion = ({
  children,
  btnText,
}: {
  children: JSX.Element;
  btnText: string;
}) => {
  const [isOpen, setIsOpen] = useState(true);
  const handleOpen = () => setIsOpen(!isOpen);

  return (
    <Box className="bg-primary-800 hidden max-lg:block">
      <H2 className="p-[2px]">
        <BannerAccordionButton
          onOpen={handleOpen}
          isOpen={isOpen}
          btnText={btnText}
        />
      </H2>
      <BannerAccordionPanel isOpen={isOpen}>{children}</BannerAccordionPanel>
    </Box>
  );
};
